import React from 'react';

import { getAudit } from '../../../../data/serviceChangeLogs';

import { ActionTabs } from '../../../../helpers/uiComponents/ActionTabs';
import AccordianTitle from '../../../../helpers/uiComponents/Accordian';

import { getCredentials } from '../../../../data/serviceClients';
import ChangeLogTable from '../../../../helpers/uiComponents/ChangeLogTable';

class ChangeLog extends React.Component {
    constructor(props) {
		super(props);
		// console.log(props);
		this.state = {
			clientAudit: [],
            contactAudit: [],
            locationAudit: [],
            siteAudit: [],
            credAudit: [],
		}
	}

    componentDidMount() {
        let client = this.props.currentClient

        getAudit("client", client.clientCode).then(resp => {
            resp.result.sort((a, b) => (a.created < b.created) ? 1 : -1)
            this.setState({clientAudit: resp.result});
        });

        let contacts = client.contacts;
        contacts.forEach(cont => {
            getAudit("contact", cont.id).then(resp => {
                let newState = this.state.contactAudit;
                resp.result.forEach(record => {
                    newState.push(record);
                    newState.sort((a, b) => (a.created < b.created) ? 1 : -1)
                });
                this.setState({contactAudit: newState});
            });
        });

        let locations = client.locations;
        locations.forEach(loc => {
            getAudit("location", loc.id).then(resp => {
                let newState = this.state.locationAudit;
                resp.result.forEach(record => {
                    newState.push(record);
                    newState.sort((a, b) => (a.created < b.created) ? 1 : -1)
                });
                this.setState({locationAudit: newState});
            });
        });

        let site = client.sites[0];
        getAudit("site", site.id).then(resp => {
            let newState = this.state.siteAudit;
            resp.result.forEach(record => {
                newState.push(record);
                newState.sort((a, b) => (a.created < b.created) ? 1 : -1)
            });
            this.setState({siteAudit: newState});
        });

        getCredentials(client.clientCode).then(response => {
			if (response.success === true) {
				var credentials = response.result.sort((a, b) => (a.group > b.group) ? 1 : -1);
				credentials.forEach(cred => {
                    getAudit("credential", cred.id).then(resp => {
                        let newState = this.state.credAudit;
                        resp.result.forEach(record => {
                            record['platform'] = cred.platform;
                            newState.push(record);
                            newState.sort((a, b) => (a.created < b.created) ? 1 : -1)
                        });
                        this.setState({credAudit: newState});
                    });
                });
			} else {
				console.log("there was an issue fetching the client credentials");
			}
		});

    }

    render() {
        const { clientAudit, contactAudit, locationAudit, siteAudit, credAudit } = this.state;
        const headings = ["Date", "Input Path", "Old Value", "New Value", "Username", "Task Id"];
        const headings2 = ["Date", "Platform", "Input Path", "Old Value", "New Value", "Username", "Task Id"];

        return(
            <div className="input-group">
                <AccordianTitle title={"Change Log"} />
                <div className="accordian-body">
                    <p>Records are in order by date/time code. Newest first, oldest last.</p>
                    <ActionTabs
                        id={"audit"}
                        tabs={[
                            {
                                "id":"account", "name": "Account Information"
                            },{
                                "id":"contact", "name": "Billing Contacts/Contacts"
                            },{
                                "id":"location", "name": "Billing/Store Locations"
                            },{
                                "id":"site", "name": "Website Information"
                            },{
                                "id":"cred", "name": "External Services"
                            }
                        ]}
                    />
                    <div id="audit-inputs" className="inputs">
                        <div id={"audit-account"} className={"tab audit-account"}>
                            <ChangeLogTable
                                headings={headings}
                                data={clientAudit}
                            />
                        </div>
                        <div id={"audit-contact"} className={"tab audit-contact"}>
                            <ChangeLogTable
                                headings={headings}
                                data={contactAudit}
                            />
                        </div>
                        <div id={"audit-location"} className={"tab audit-location"}>
                            <ChangeLogTable
                                headings={headings}
                                data={locationAudit}
                            />
                        </div>
                        <div id={"audit-site"} className={"tab audit-site"}>
                            <ChangeLogTable
                                headings={headings}
                                data={siteAudit}
                            />
                        </div>
                        <div id={"audit-cred"} className={"tab audit-cred"}>
                            <ChangeLogTable
                                headings={headings2}
                                data={credAudit}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default ChangeLog;


// WEBPACK FOOTER //
// ./src/component_client/components/ClientProfile/ProfileComponents/ChangeLog.js